<template>
  <nav class="app-header navbar navbar-expand bg-white shadow-sm">
    <!--begin::Container-->
    <div class="container-fluid">
      
      <!-- القائمة اليمنى (زر السايدبار) -->
     <ul class="navbar-nav">
        <li class="nav-item">
          <!-- التعديل هنا: استخدام @click.prevent وإرسال إشارة toggle-sidebar -->
          <a class="nav-link" href="#" @click.prevent="$emit('toggle-sidebar')" role="button">
            <i class="fas fa-bars"></i>
          </a>
           <!-- <a class="nav-link" href="#" data-lte-toggle="fullscreen">
                <i data-lte-icon="maximize" class="bi bi-arrows-fullscreen"></i>
                <i data-lte-icon="minimize" class="bi bi-fullscreen-exit" style="display: none"></i>
              </a>
                <a class="nav-link" data-lte-toggle="sidebar" href="#" role="button">
                <i class="bi bi-list"></i>
              </a> -->
        </li>
      </ul>

   
              <button @click="$emit('logout')" class="btn btn-danger btn-flat">
                <i class="fas fa-sign-out-alt me-1"></i> خروج
              </button>
<!-- <button @click="askPermission">تفعيل الإشعارات</button> -->
      
    </div>
    <!--end::Container-->
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    userName: {
      type: String,
      default: "مستخدم النظام"
    },
    userRole: {
      type: String,
      default: "مسئول النظام"
    },
    userImage: {
      type: String,
      default: "" // مسار افتراضي للصورة
    }
  },
  emits: ['logout', 'toggle-sidebar'],

  methods: {
      askPermission() {
    Notification.requestPermission().then((permission) => {
      console.log("Permission:", permission);
    });
  }
  },
};
</script>

<style scoped>
/* تحسينات عامة للناف بار */
.app-header {
  border-bottom: 1px solid #dee2e6;
  min-height: 60px;
}

/* تنسيق الروابط */
.navbar-nav .nav-link {
  color: #5a5a5a;
  padding: 0.5rem 1rem;
  transition: color 0.3s;
}

.navbar-nav .nav-link:hover {
  color: #0d6efd; /* لون أزرق عند التحويم */
}

/* تنسيق الشارات (Badges) */
.navbar-badge {
  font-size: 0.6rem;
  font-weight: 300;
  padding: 2px 4px;
  position: absolute;
  right: 5px;
  top: 9px;
  border-radius: 50%;
}

/* تحسين قائمة المستخدم */
.user-menu .user-image {
  float: right; /* للعربية */
  width: 30px;
  height: 30px;
  margin-left: 10px;
}

.user-header {
  background-color: #0d6efd !important; /* لون الخلفية الأزرق */
  padding: 20px;
  text-align: center;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.user-header img {
  width: 90px;
  height: 90px;
  border: 3px solid rgba(255, 255, 255, 0.2);
}

.user-footer {
  background-color: #f8f9fa;
  padding: 10px;
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.dropdown-menu-lg {
  min-width: 280px;
}

/* ضبط الاتجاهات للعربية */
.dropdown-menu-end {
  right: auto;
  left: 0;
}

.ms-auto {
  margin-right: auto !important;
  margin-left: 0 !important;
}
</style>